import { map, setMap } from './index'
import mapStyles from './styles'
import { setOpenRoute, openRoute, markers, viewportMarkers, clearViewportMarkers } from '../markers'
import createMarker from '../markers/createMarker'
import { MarkerClusterer } from '../marker-clusterer'
import { infoBoxes } from '../utils/infoBox'
import { polylines, clearPolylines } from '../polylines'
import removeResultList from '../result-list/removeResultList'
import createLoader from '../utils/loader/createLoader'
import paddedBounds from './setPaddingToMap'

export const createMap = opts => {
  const { id, center, zoom, minZoom, maxZoom } = opts.map
  const map = new google.maps.Map(document.getElementById(id), {
    zoom,
    center,
    styles: mapStyles,
    mapTypeId: google.maps.MapTypeId.ROADMAP,
    mapTypeControl: false,
    maxZoom,
    minZoom,
    disableDefaultUI: true
  })

  setMap(map)

  // add language
  $(`#${id}`).addClass(opts.lang)

  map.addListener('click', function(e) {
    if(!openRoute)
      return

    createLoader()

    // add padding to map so markers beneath offers does not laod
    let paddedMapBounds = null
    let paddedOffsets = [10, 160, 10, 10]
    if(window.innerWidth <= 480) {
      paddedOffsets = [10, 10, 10, 10]
    }
    paddedMapBounds = paddedBounds(...paddedOffsets)

    $('#airticket-map-offers').removeClass('hide')
    $('#airticket-map-offers ul').slick('slickPlay') // play slick slider

    removeResultList()

    for (let i = 0; i < infoBoxes.length; i++) {
      infoBoxes[i].close()
    }

    for (let i = 0; i < polylines.length; i++) {
      polylines[i].setMap(null)
    }

    clearPolylines()

    // markers reset in vewport so new can be added
    clearViewportMarkers()

    for (let i = 0; i < markers.length; i++) {
      const marker = createMarker(markers[i])

      if(paddedMapBounds.contains(marker.getPosition())) {
        viewportMarkers.push(marker)
      }
    }

    const options = {
      imagePath: 'images/m'
    }

    new MarkerClusterer(map, viewportMarkers, options);

    setOpenRoute(false)
  })
}



// WEBPACK FOOTER //
// ./app/map/createMap.js